import { render, staticRenderFns } from "./onebox-directoryfile-scrolling-new.vue?vue&type=template&id=72b9699b&scoped=true&"
import script from "./onebox-directoryfile-scrolling-new.vue?vue&type=script&lang=js&"
export * from "./onebox-directoryfile-scrolling-new.vue?vue&type=script&lang=js&"
import style0 from "./onebox-directoryfile-scrolling-new.vue?vue&type=style&index=0&id=72b9699b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b9699b",
  null
  
)

export default component.exports